import React, { useState, useContext, useEffect } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, TextField, Button } from '@mui/material';
import { useAuthContext } from '../../../context/auth/AuthContext';
import { ToastType, useToast } from '../../../context/toast/ToastContext';
import { useLoadingContext } from '../../../context/loading/LoadingContext';
import Logo from '../../../resources/images/logo/bizismart.png'
import { useTranslation } from 'react-i18next';
import { StringKeys } from '../../../resources/strings/StringKeys';

const ForgotPasswordModal = ({ show, onHide }) => {
    const [email, setEmail] = useState("");
    const [error, setError] = useState("");
    const { resetEmail } = useAuthContext()
    const { showToast } = useToast();
    const { setLoadingData } = useLoadingContext();
    const { t } = useTranslation();

    const handleResetPassword = async () => {
        if (!email) {
            setError(t(StringKeys.PLEASE_ENTER_YOUR_EMAIL_ADDRESS));
            return;
        }
        setLoadingData(true);
        const response = await resetEmail(email);
        setLoadingData(false);
        if (response.error) {
            if(response.error === 'Firebase: Error (auth/invalid-email).') {
                setError(t(StringKeys.INVALID_EMAIL_PLEASE_TRY_AGAIN))
            } else {
                setError(t(StringKeys.SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN))
            }
        } else {
            showToast(t(StringKeys.PASSWORD_RESET_EMAIL_SENT), ToastType.SUCCESS);
            onHide();
        }
    };
    
    const resetForm = () => {
        setEmail("")
        setError("")
    }

    useEffect(() => {
        if(!show) {
            resetForm()
        }
    },[show])

    return (
        <Dialog open={show} onClose={onHide}>
            <DialogTitle><img src={Logo} alt="logo" style={{ height: '30px', marginRight:"20px" }} />{t(StringKeys.RESET_PASSWORD)}</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    id="email"
                    label={t(StringKeys.EMAIL_ADDRESS)}
                    type="email"
                    fullWidth
                    variant="outlined"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    error={!!error}
                    helperText={error || t(StringKeys.ENTER_YOUR_EMAIL_ADDRESS_TO_RESET_YOUR_PASSWORD)}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onHide}>{t(StringKeys.CANCEL)}</Button>
                <Button onClick={handleResetPassword}>{t(StringKeys.SEND_RESET_EMAIL)}</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ForgotPasswordModal;
